import {
    Button,
    Card,
    CardContent,
    Typography,
    CardActions,
} from "@mui/material";

export const CardCategory = (props: {
    icon: any;
    title: string;
    subtitle: string;
    btnTitle: string;
    handleExist: () => void;
}) => {
    const Icon = props.icon;
    return (
        <Card
            sx={{
                width: 280,
                height: 332,
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
            }}
        >
            <CardContent sx={{ textAlign: "center", marginTop: "24px"}}>
                <Icon style={{ width: 50, height: 50 }} />
                <Typography
                    variant="h5"
                    component="div"
                    fontSize={16}
                    fontWeight={700}
                    lineHeight="24px"
                    fontFamily="Josefin Sans"
                    marginTop="16px"
                    marginBottom="8px"
                >
                    {props.title}
                </Typography>
                <Typography
                    variant="body2"
                    fontSize={12}
                    fontWeight={400}
                    lineHeight="18px"
                    fontFamily="Josefin Sans"
                    margin="12px 0"
                >
                    {props.subtitle}
                </Typography>
            </CardContent>
            <CardActions
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "flex-end",
                    marginBottom: "20px",
                }}
            >
                <Button
                    size="small"
                    sx={{
                        textTransform: "none",
                        fontFamily: "Josefin Sans",
                        fontSize: 14,
                        fontWeight: 500,
                        lineHeight: "20px",
                        padding: "10px 20px",
                        color: "#FFFFFF",
                        backgroundColor: "#880608",
                        "&:hover": { backgroundColor: "#B5551B " },
                    }}
                    onClick={props.handleExist}
                >
                    {props.btnTitle}{" "}
                </Button>
            </CardActions>
        </Card>
    );
};
